import { useParams } from "react-router-dom";
import { CourseDetails } from "./details.js";
import { useLocation, Link } from "react-router-dom";
import { Settings } from "../settings/index.js";
import { Reviews } from "../reviews/index.js";
import { Participants } from "../participants/index.js";
import { Breadcrumbs } from "../../../components/breadcrumbs/index.jsx";
import { capitalize } from "../../../helper/join.js";
import { Chapters } from "../chapters/index.jsx";
import { deslugify } from "../../../helper/paramString.js";
import { EventResponse } from "../../../pages/eventResponse/index.js";

export const Course = () => {
  const { type, title } = useParams();
  const location = useLocation();

  let aside = [{ title: "Details", route: `/offerings/${type}/${title}` }];

  if (type?.includes("course") || type?.includes("training")) {
    aside = [
      ...aside,
      {
        title: "Chapters & Topics",
        route: `/offerings/${type}/${title}/chapters`,
      },
    ];
  }

  aside = [
    ...aside,
    { title: "Reviews", route: `/offerings/${type}/${title}/reviews` },
    {
      title: "Additional Settings",
      route: `/offerings/${type}/${title}/settings`,
    },
  ];

  if (type?.includes("event")) {
    aside = [
      ...aside,
      {
        title: "Event Response",
        route: `/offerings/${type}/${title}/event-response`,
      },
    ];
  }

  if (type?.includes("course") || type?.includes("training")) {
    aside = [
      ...aside,
      { title: "Tracking", route: `/offerings/${type}/${title}/tracking` },
    ];
  }

  return (
    <div>
      <aside
        id="sidebar-multi-level-sidebar"
        className="md:fixed top-16 z-30 md:w-56 md:h-screen transition-transform translate-x-0"
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-100">
          <ul className="space-y-2">
            {aside.map((item, index) => {
              return (
                <li key={index}>
                  <div
                    className={`flex items-center p-2 transition rounded-full duration-200 ease-out group ${
                      location.pathname === item.route
                        ? "bg-orange-500 text-white"
                        : "text-gray-900 hover:bg-orange-200"
                    }`}
                  >
                    <Link to={item.route} className="ms-3">
                      {`> ${item.title}`}
                    </Link>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </aside>

      <div className="md:ml-52 h-max">
        <Breadcrumbs
          breadcrumbs={[
            { name: capitalize(type), link: `/offerings/${type}` },
            {
              name: `${
                location.pathname.includes("/settings")
                  ? "Settings"
                  : location.pathname.includes("/reviews")
                  ? "Reviews"
                  : location.pathname.includes("/chapters")
                  ? "Chapters & Topics"
                  : location.pathname.includes("/event-response")
                  ? "Event Response"
                  : "Details"
              } (${deslugify(title)})`,
              link: location?.pathname,
            },
          ]}
        />
        <div className="p-4 m-4 border-2 border-gray-200 border-dashed rounded-lg md:mx-[55px]">
          {location.pathname.includes("/settings") ? (
            <Settings />
          ) : location.pathname.includes("/reviews") ? (
            <Reviews />
          ) : location.pathname.includes("/chapters") ? (
            <Chapters />
          ) : location.pathname.includes("/tracking") ? (
            <Participants title={title} />
          ) : location.pathname.includes("/event-response") ? (
            <EventResponse />
          ) : (
            <CourseDetails title={title} />
          )}
        </div>
      </div>
    </div>
  );
};
